// With site data blocked, even reading `window.localStorage` throws a
// SecurityError (Sentry RMP-WEB-3C). These wrappers never throw.
interface SafeStorage {
  getItem(key: string): string | null;
  /** False when the value could not be persisted (storage denied or full). */
  setItem(key: string, value: string): boolean;
  removeItem(key: string): void;
}

function createSafeStorage(getStorage: () => Storage): SafeStorage {
  return {
    getItem(key) {
      try {
        return getStorage().getItem(key);
      } catch {
        return null;
      }
    },
    setItem(key, value) {
      try {
        getStorage().setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    removeItem(key) {
      try {
        getStorage().removeItem(key);
      } catch {
        // Nothing to remove if storage is unreachable.
      }
    },
  };
}

export const safeLocalStorage = createSafeStorage(() => localStorage);
export const safeSessionStorage = createSafeStorage(() => sessionStorage);
